var i = Object.defineProperty, p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var t = (o, e, r) => e in o ? i(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, m = (o, e) => {
  for (var r in e || (e = {}))
    c.call(e, r) && t(o, r, e[r]);
  if (a)
    for (var r of a(e))
      d.call(e, r) && t(o, r, e[r]);
  return o;
}, f = (o, e) => p(o, s(e));
import n, { forwardRef as y } from "react";
import b from "../lib/IconBase.mjs";
import l from "../defs/Keyboard.mjs";
const w = y((o, e) => /* @__PURE__ */ n.createElement(b, f(m({ ref: e }, o), { weights: l })));
w.displayName = "Keyboard";
export {
  w as Keyboard
};
